<template>
  <div class="DownloadButton">
    <v-btn
      ref="downloadButton"
      :class="{ 'white--text': downloadButtonColor }"
      block
      :color="downloadButtonColor"
      :outlined="!downloadButtonColor"
      rounded
      :aria-label="downloadBtnAriaLabel"
      :data-test-id="dataTestId"
      @click="onDownload"
    >
      <span>{{ buttonText }}</span>
      <v-icon :color="downloadButtonColor ? undefined : 'muted'">{{
        mdiCloudDownload
      }}</v-icon>
    </v-btn>
  </div>
</template>

<script>
import { mdiCloudDownload } from "@mdi/js";
import { mapState } from "vuex";

export default {
  props: {
    buttonText: { type: String, default: "Download" },
    fileName: { type: String, required: true },
    fileType: { type: String, required: true },
    fileSize: { type: String, default: null },
    fileSource: { type: String, required: true },
    dataTestId: { type: [String, null], default: null },
  },
  data() {
    return {
      mdiCloudDownload,
    };
  },
  computed: {
    ...mapState({
      downloadButtonColor: (state) =>
        state.theme.layout.articleDetailsDownloadButtonColor,
    }),
    downloadBtnAriaLabel() {
      return `Download ${this.fileName} ${this.fileType} ${
        this.fileSize ? `,${this.fileSize} megabytes` : ""
      }. Opens in a new tab`;
    },
  },
  methods: {
    onDownload() {
      const url = this.fileSource;

      if (url) {
        window.open(url, "_blank");
      }
    },
  },
};
</script>

<style>
.DownloadButton .v-btn .v-icon {
  margin-left: 8px;
}
</style>
